const { getDate } = require('./getDate')

/**
 * Visszaadja az aktuális év-hónap-napot.
 * @returns {string} Az ISO dátum: YYYY-mm-dd.
 */
module.exports.getCurrentDate = function getCurrentDate () {
  return getDate(new Date())
}
